module.exports = __webpack_public_path__ + "img/tedxryerson-min.bdf4fcc0.png";